import EmptyScreen from "./EmptyScreen";

const EmptySeach = ({ description }: { description: string }) => {
  return (
    <>
      <div className="w-full flex flex-col gap-y-2 mt-5 lg:mt-0">
        <h1 className="font-bold text-lg">Kết quả tìm kiếm</h1>
        <p className="text-base text-light_grey ">
          Không tìm thấy kết quả nào phù hợp
        </p>
      </div>
      <EmptyScreen description={description} />
    </>
  );
};

export default EmptySeach